import * as PostalAddressOriginal from 'i18n-postal-address';

const PostalAddress: any = PostalAddressOriginal.default;
export default PostalAddress;
